export const OptionSelect = [
  { value: "all_12_2022", label: "Báo cáo 12 tháng 2022" },
  { value: "6_2023", label: "Báo cáo 6 tháng đầu 2023" },
  { value: "all_12_2023", label: "Báo cáo 12 tháng 2023" },
  { value: "6_2024", label: "Báo cáo 6 tháng đầu 2024" },
  { value: "all_12_2024", label: "Báo cáo 12 tháng 2024" },
  { value: "6_2025", label: "Báo cáo 6 tháng đầu 2025" },
  { value: "all_12_2025", label: "Báo cáo 12 tháng 2025" },
];
